import { useContext } from 'react'
import SolicitacoesKanbanContext from './context'

const useSolicitacoesKanban = () => {
  const auth = useContext(SolicitacoesKanbanContext)
  return auth
}

export default useSolicitacoesKanban
